import type { FunctionComponent } from 'react';

import { Button, ThemeProvider } from '@dr.pogodin/react-utils';

import IconFilters from 'assets/images/icon-filters-24px.svg';
import IconVideo from 'assets/images/icon-video-24px.svg';

import tabHandleTheme from 'themes/Button/admin/tab-handle.scss';

import './style.scss';

export type TabT = 'SPECS' | 'UPLOAD';

type PropsT = {
  canGoToSpecs: boolean;
  setTab: (tab: TabT) => void;
  tab: TabT;
};

const Header: FunctionComponent<PropsT> = ({ canGoToSpecs, setTab, tab }) => (
  <ThemeProvider themes={{ Button: tabHandleTheme }}>
    <div styleName="container">
      <Button
        active={tab === 'UPLOAD'}
        onClick={() => {
          setTab('UPLOAD');
        }}
      >
        <IconVideo /> Upload Video
      </Button>
      <Button
        active={tab === 'SPECS'}
        disabled={!canGoToSpecs}
        onClick={() => {
          setTab('SPECS');
        }}
      >
        <IconFilters /> Video Specifications
      </Button>
    </div>
  </ThemeProvider>
);

export default Header;
